import { DataCache, QueryResultRelationship, SharedKeyRelationship } from 'lib/DataCache';
import { PCCache, PCCollection } from 'data/PCCache';

import { WartsilaEnrichmentsResponse } from 'data/models/WartsilaEnrichmentsResponse';

export class WartsilaEnrichmentsCache extends DataCache {
    WartsilaEnrichmentsResponses = PCCollection(WartsilaEnrichmentsResponse);

    constructor(data : PCCache) {
        super();

        new SharedKeyRelationship   (this.WartsilaEnrichmentsResponses, data.PortCalls, r => r.PortCall, null);
        new QueryResultRelationship (this.WartsilaEnrichmentsResponses, data.WartsilaEnhancedEstimateQueries, r => r.RelevantQuery);
    }
}



// WEBPACK FOOTER //
// ./apps/wartsila/wartsilaenrichments/cache.ts